import { render } from "./EnquireModal.vue?vue&type=template&id=12b0cc41"
import script from "./EnquireModal.vue?vue&type=script&lang=js"
export * from "./EnquireModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__